const steps = [
  {
    number: '01',
    title: 'Audit',
    description:
      'We review your code, architecture, and infrastructure in depth. You receive a clear report of what is broken, what is risky, and what needs to happen before this goes anywhere near production.',
  },
  {
    number: '02',
    title: 'Fix',
    description:
      'We address the weak spots — tests, CI/CD, security hardening, performance, observability. No throwaway rewrites. Surgical, targeted improvements that make the system solid.',
  },
  {
    number: '03',
    title: 'Ship',
    description:
      'Deployed, monitored, and documented. You get a production-grade system with runbooks and handover notes. Not a prototype — something you can build a business on.',
  },
];

export default function HowItWorks() {
  return (
    <section className="hiw-section">
      <div className="section-inner">
        <h2 className="section-title">How It Works</h2>
        <p className="section-subtitle">
          Three steps from broken to production-ready.
        </p>
        <div className="hiw-steps">
          {steps.map((step) => (
            <div key={step.number} className="hiw-step">
              <span className="hiw-step-number">{step.number}</span>
              <h3 className="hiw-step-title">{step.title}</h3>
              <p className="hiw-step-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
